module.exports = __webpack_public_path__ + "fc66e7f03cf49d2bf825e3f9d89a55e7.pdf";